import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import {
  Box,
  Heading,
  HStack,
  Center,
  Text,
  Switch,
  Flex,
  Button,

} from '@chakra-ui/react';
import 'react-toastify/dist/ReactToastify.css';
import DailyTable from './DailyTable';
import WeeklyTable from './WeeklyTable';
import AllLogsTable from './Allogs';
import Timer from './Timer';
import { FaPhoneAlt, FaChartBar } from "react-icons/fa";
import { AiTwotoneThunderbolt } from "react-icons/ai";
import { Helmet } from "react-helmet-async";



function IntelliAssign() {
  const [isOn, setIsOn] = useState(false);
  const [logData, setLogData] = useState([]);


  const getNowCSTString = () => {
    const now = new Date();
    const parts = now.toLocaleString("en-US", {
      timeZone: "America/Chicago",
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    const [datePart, timePart] = parts.split(", ");
    const [month, day, year] = datePart.split("/");
    return `${year}-${month}-${day}T${timePart}`;
  };

  const parseCSTDate = (cstStr) => {
    const [datePart, timePart] = cstStr.split("T");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);

    const date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));

    const getSecondSunday = (year, month) => {
      const d = new Date(Date.UTC(year, month, 1));
      const day = d.getUTCDay();
      let firstSunday = 1 + ((7 - day) % 7);
      return firstSunday + 7;
    };
    const getFirstSunday = (year, month) => {
      const d = new Date(Date.UTC(year, month, 1));
      const day = d.getUTCDay();
      return 1 + ((7 - day) % 7);
    };

    const marchSecondSunday = new Date(Date.UTC(year, 2, getSecondSunday(year, 2)));
    const novFirstSunday = new Date(Date.UTC(year, 10, getFirstSunday(year, 10)));

    let isDST = (date >= marchSecondSunday) && (date < novFirstSunday);
    const offsetHours = isDST ? 5 : 6;

    date.setUTCHours(date.getUTCHours() + offsetHours);
    return date;
  };


  const formatDuration = (minutesWithSeconds) => {
    const totalSeconds = Math.round(minutesWithSeconds * 60);
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    return `${hrs} hrs ${mins} m`;
  };

  const getWeekStart = (cstStr) => {
    const date = parseCSTDate(cstStr);
    const dayOfWeek = date.getDay();
    const sunday = new Date(date);
    sunday.setDate(date.getDate() - dayOfWeek);

    return sunday.toLocaleDateString("en-US", {
      timeZone: "America/Chicago",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  useEffect(() => {
    const savedLogs = JSON.parse(localStorage.getItem('intelliLogs')) || [];
    const savedState = JSON.parse(localStorage.getItem('intelliState')) || { isOn: false };
    setLogData(savedLogs);
    setIsOn(savedState.isOn);
  }, []);

  const handleToggle = () => {
    const nowCST = getNowCSTString();
    let updatedLogs = [...logData];

    if (!isOn) {
      updatedLogs.push({ on: nowCST, off: null });
      toast.success('Intelli Assign is ACTIVE 💯', { position: 'top-right' });
    } else {
      const last = updatedLogs[updatedLogs.length - 1];
      if (last && !last.off) {
        last.off = nowCST;
      }
      toast.error(' Intelli Assign is OFF ❌', { position: 'top-right' });
    }

    setIsOn(!isOn);
    setLogData(updatedLogs);
    localStorage.setItem('intelliLogs', JSON.stringify(updatedLogs));
    localStorage.setItem('intelliState', JSON.stringify({ isOn: !isOn }));
  };

  const processLogs = () => {
    const dayMap = {};
    const weekMap = {};

    logData.forEach(({ on, off }) => {
      if (!on || !off) return;

      let start = parseCSTDate(on);
      let end = parseCSTDate(off);

      while (start < end) {
        const nextMidnight = new Date(start);
        nextMidnight.setHours(24, 0, 0, 0);

        const segmentEnd = end < nextMidnight ? end : nextMidnight;
        const durationMinutes = (segmentEnd - start) / 1000 / 60;

        const dayKey = start.toLocaleDateString("en-US", {
          timeZone: "America/Chicago",
          day: "numeric",
          month: "long",
          year: "numeric",
        });

        const weekKey = getWeekStart(start.toISOString());

        dayMap[dayKey] = (dayMap[dayKey] || 0) + durationMinutes;
        weekMap[weekKey] = (weekMap[weekKey] || 0) + durationMinutes;

        start = segmentEnd;
      }
    });

    const dayArray = Object.entries(dayMap).map(([date, minutes]) => ({ date, minutes }));
    const weekArray = Object.entries(weekMap).map(([week, minutes]) => ({ week, minutes }));


    return { dayArray, weekArray };
  };

  const { dayArray, weekArray } = processLogs();


  const handleLogs = () => {
    const existingData = localStorage.getItem("intelliLogs");

    if (existingData) {
      navigator.clipboard
        .writeText(existingData)
        .then(() => {
          toast.success('Copied to Clipboard', { position: 'bottom-right' });
        })
        .catch((err) => {
          toast.error('Something went wrong', { position: 'bottom-right' });

        });
    } else {
      toast.error('no data found', { position: 'bottom-right' });

    }
  };
  // Get the latest week


  return (
    <Box p={6} fontFamily="sans-serif">
      <Helmet>
        <title>
          {isOn ? "Active 🟢 - Intelli Assign" : "Intelli Assign Tracker - OFF "}
        </title>
      </Helmet>
      <ToastContainer />

      <Center mt={10} mb={10}>
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Intelli Assign</Text>
          <Switch size="lg" colorScheme="green" isChecked={isOn} onChange={handleToggle} />
          <Text>{isOn ? 'ON' : 'OFF'}</Text>
        </Flex>
      </Center>
      <Timer isOn={isOn} logData={logData} />




      {/* <Box m="auto" w="70%" mt={8}>
        <Chart options={dayChart.options} series={dayChart.series} type="bar" height={300} />
      </Box> */}
      <WeeklyTable data={weekArray} rawLogs={logData} formatDuration={formatDuration} parseCSTDate={parseCSTDate} />
      <DailyTable data={dayArray} rawLogs={logData} formatDuration={formatDuration} parseCSTDate={parseCSTDate} />
      <Box mt={20}>

        <AllLogsTable handleLogs={handleLogs} rawLogs={logData} />


      </Box>
      <Box

        p={6}
        borderRadius="lg"

        textAlign="center"
      >
        <Heading size="sm" color="gray.500" mb={4}>
          Explore Other Tools
        </Heading>

        <HStack spacing={4} justify="center">
           <Button
            as="a"
            href="https://myquicklinks.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
            leftIcon={<AiTwotoneThunderbolt />}
            variant="ghost"
            color="orange.500"
            _hover={{ color: "green.500" }}
          >
            Quick Links
          </Button>
          <Button
            as="a"
            href="https://ghlsuperadvisor.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
            leftIcon={<AiTwotoneThunderbolt />}
            variant="ghost"
            color="orange.500"
            _hover={{ color: "green.500" }}
          >
            GHL Super Advisor
          </Button>

          <Button
            as="a"
            href="https://trackcount.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
            leftIcon={<FaPhoneAlt />}
            variant="ghost"
            color="orange.500"
            _hover={{ color: "green.500" }}
          >
            Track Count
          </Button>

          <Button
            as="a"
            href="https://advisorstats.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
            leftIcon={<FaChartBar />}
            variant="ghost"
            color="orange.500"
            _hover={{ color: "green.500" }}
          >
            Advisors Stats Dashboard
          </Button>
        </HStack>
      </Box>
      <Text mt={5} align="center">Built by K I N G 👾</Text>
    </Box>
  );
}

export default IntelliAssign;
